var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-row",
        { staticClass: "stats-row", attrs: { gutter: 16 } },
        [
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-card",
                { staticClass: "stat-card", attrs: { shadow: "hover" } },
                [
                  _c("div", { staticClass: "stat-content" }, [
                    _c("div", { staticClass: "stat-icon total" }, [
                      _c("i", { staticClass: "el-icon-s-order" }),
                    ]),
                    _c("div", { staticClass: "stat-info" }, [
                      _c("div", { staticClass: "stat-value" }, [
                        _vm._v(_vm._s(_vm.purchaseStats.total)),
                      ]),
                      _c("div", { staticClass: "stat-label" }, [
                        _vm._v("Total Purchases"),
                      ]),
                    ]),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-card",
                { staticClass: "stat-card", attrs: { shadow: "hover" } },
                [
                  _c("div", { staticClass: "stat-content" }, [
                    _c("div", { staticClass: "stat-icon active" }, [
                      _c("i", { staticClass: "el-icon-success" }),
                    ]),
                    _c("div", { staticClass: "stat-info" }, [
                      _c("div", { staticClass: "stat-value" }, [
                        _vm._v(_vm._s(_vm.purchaseStats.active)),
                      ]),
                      _c("div", { staticClass: "stat-label" }, [
                        _vm._v("Active"),
                      ]),
                    ]),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-card",
                { staticClass: "stat-card", attrs: { shadow: "hover" } },
                [
                  _c("div", { staticClass: "stat-content" }, [
                    _c("div", { staticClass: "stat-icon inactive" }, [
                      _c("i", { staticClass: "el-icon-error" }),
                    ]),
                    _c("div", { staticClass: "stat-info" }, [
                      _c("div", { staticClass: "stat-value" }, [
                        _vm._v(_vm._s(_vm.purchaseStats.inactive)),
                      ]),
                      _c("div", { staticClass: "stat-label" }, [
                        _vm._v("Inactive"),
                      ]),
                    ]),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-card",
                { staticClass: "stat-card", attrs: { shadow: "hover" } },
                [
                  _c("div", { staticClass: "stat-content" }, [
                    _c("div", { staticClass: "stat-icon week" }, [
                      _c("i", { staticClass: "el-icon-date" }),
                    ]),
                    _c("div", { staticClass: "stat-info" }, [
                      _c("div", { staticClass: "stat-value" }, [
                        _vm._v(_vm._s(_vm.purchaseStats.thisWeek)),
                      ]),
                      _c("div", { staticClass: "stat-label" }, [
                        _vm._v("This Week"),
                      ]),
                    ]),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-card",
                { staticClass: "stat-card", attrs: { shadow: "hover" } },
                [
                  _c("div", { staticClass: "stat-content" }, [
                    _c("div", { staticClass: "stat-icon month" }, [
                      _c("i", { staticClass: "el-icon-calendar" }),
                    ]),
                    _c("div", { staticClass: "stat-info" }, [
                      _c("div", { staticClass: "stat-value" }, [
                        _vm._v(_vm._s(_vm.purchaseStats.thisMonth)),
                      ]),
                      _c("div", { staticClass: "stat-label" }, [
                        _vm._v("This Month"),
                      ]),
                    ]),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 4 } },
            [
              _c(
                "el-card",
                {
                  staticClass: "stat-card refresh-card",
                  attrs: { shadow: "hover" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "stat-content" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "text", icon: "el-icon-refresh" },
                          on: { click: _vm.loadPurchaseStats },
                        },
                        [_vm._v(" Refresh Stats ")]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c("el-date-picker", {
            staticClass: "filter-item",
            staticStyle: { width: "150px" },
            attrs: {
              type: "date",
              placeholder: "Start Date",
              "value-format": "yyyy-MM-dd",
            },
            model: {
              value: _vm.startDate,
              callback: function ($$v) {
                _vm.startDate = $$v
              },
              expression: "startDate",
            },
          }),
          _c("el-date-picker", {
            staticClass: "filter-item",
            staticStyle: { width: "150px" },
            attrs: {
              type: "date",
              placeholder: "End Date",
              "value-format": "yyyy-MM-dd",
            },
            model: {
              value: _vm.endDate,
              callback: function ($$v) {
                _vm.endDate = $$v
              },
              expression: "endDate",
            },
          }),
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              staticStyle: { width: "120px" },
              attrs: { placeholder: "Platform", clearable: "" },
              model: {
                value: _vm.listQuery.platform,
                callback: function ($$v) {
                  _vm.$set(_vm.listQuery, "platform", $$v)
                },
                expression: "listQuery.platform",
              },
            },
            [
              _c("el-option", {
                attrs: { label: "Android", value: "android" },
              }),
              _c("el-option", { attrs: { label: "iOS", value: "ios" } }),
            ],
            1
          ),
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              staticStyle: { width: "150px" },
              attrs: { placeholder: "Event Type", clearable: "" },
              model: {
                value: _vm.listQuery.eventType,
                callback: function ($$v) {
                  _vm.$set(_vm.listQuery, "eventType", $$v)
                },
                expression: "listQuery.eventType",
              },
            },
            [
              _c("el-option", {
                attrs: { label: "Purchase", value: "purchase" },
              }),
              _c("el-option", {
                attrs: { label: "Renewal", value: "renewal" },
              }),
              _c("el-option", { attrs: { label: "Cancel", value: "cancel" } }),
              _c("el-option", { attrs: { label: "Expire", value: "expire" } }),
              _c("el-option", { attrs: { label: "Refund", value: "refund" } }),
              _c("el-option", {
                attrs: { label: "Renewal Failed", value: "renewal_failed" },
              }),
              _c("el-option", {
                attrs: { label: "Grace Period", value: "grace_period" },
              }),
              _c("el-option", { attrs: { label: "Hold", value: "hold" } }),
              _c("el-option", { attrs: { label: "Pause", value: "pause" } }),
              _c("el-option", {
                attrs: { label: "Reactivate", value: "reactivate" },
              }),
              _c("el-option", {
                attrs: { label: "Unknown", value: "unknown" },
              }),
            ],
            1
          ),
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              staticStyle: { width: "150px" },
              attrs: { placeholder: "Status", clearable: "" },
              model: {
                value: _vm.listQuery.status,
                callback: function ($$v) {
                  _vm.$set(_vm.listQuery, "status", $$v)
                },
                expression: "listQuery.status",
              },
            },
            [
              _c("el-option", { attrs: { label: "Active", value: "active" } }),
              _c("el-option", {
                attrs: { label: "Cancelled", value: "cancelled" },
              }),
              _c("el-option", {
                attrs: { label: "Expired", value: "expired" },
              }),
              _c("el-option", {
                attrs: { label: "In Grace Period", value: "in_grace_period" },
              }),
              _c("el-option", {
                attrs: { label: "On Hold", value: "on_hold" },
              }),
              _c("el-option", { attrs: { label: "Paused", value: "paused" } }),
              _c("el-option", {
                attrs: { label: "Refunded", value: "refunded" },
              }),
            ],
            1
          ),
          _c("user-search", {
            staticClass: "filter-item",
            staticStyle: { width: "250px" },
            attrs: {
              placeholder: "Search user...",
              "show-selected-info": false,
            },
            model: {
              value: _vm.listQuery.userId,
              callback: function ($$v) {
                _vm.$set(_vm.listQuery, "userId", $$v)
              },
              expression: "listQuery.userId",
            },
          }),
          _c(
            "el-checkbox",
            {
              staticClass: "filter-item",
              staticStyle: { "margin-left": "10px" },
              model: {
                value: _vm.listQuery.includeTest,
                callback: function ($$v) {
                  _vm.$set(_vm.listQuery, "includeTest", $$v)
                },
                expression: "listQuery.includeTest",
              },
            },
            [_vm._v(" Include test purchases ")]
          ),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.handleFilter },
            },
            [_vm._v(" Search ")]
          ),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { icon: "el-icon-refresh" },
              on: { click: _vm.handleRefresh },
            },
            [_vm._v(" Refresh ")]
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { staticStyle: { "margin-bottom": "15px" }, attrs: { gutter: 10 } },
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            _vm._l(_vm.statistics, function (stat, index) {
              return _c(
                "el-tag",
                {
                  key: index,
                  staticStyle: { "margin-right": "10px" },
                  attrs: { type: _vm.getEventTypeTag(stat.event_type) },
                },
                [
                  _c("i", {
                    class: _vm.getEventTypeIcon(stat.event_type),
                    staticStyle: { "margin-right": "4px" },
                  }),
                  _vm._v(
                    " " +
                      _vm._s(_vm.getEventTypeLabel(stat.event_type)) +
                      ": " +
                      _vm._s(stat.count) +
                      " "
                  ),
                ]
              )
            }),
            1
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.events,
            border: "",
            fit: "",
            "highlight-current-row": "",
            "row-class-name": _vm.getRowClassName,
          },
        },
        [
          _c("el-table-column", {
            attrs: { label: "ID", align: "center", width: "70" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("span", { staticClass: "event-id" }, [
                      _vm._v(_vm._s(row.id)),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Event", align: "left", width: "280" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("div", { staticClass: "event-type-cell" }, [
                      _c(
                        "div",
                        { staticClass: "event-main" },
                        [
                          _c("i", {
                            staticClass: "event-icon",
                            class: _vm.getEventTypeIcon(row.event_type),
                            style: {
                              color: _vm.getEventTypeColor(row.event_type),
                            },
                          }),
                          _c(
                            "el-tag",
                            {
                              staticClass: "event-tag",
                              attrs: {
                                type: _vm.getEventTypeTag(row.event_type),
                                size: "small",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.getEventTypeLabel(row.event_type)
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      row.event_subtype && row.event_subtype !== row.event_type
                        ? _c("div", { staticClass: "event-subtype" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.getEventSubtypeLabel(row.event_subtype)
                                ) +
                                " "
                            ),
                          ])
                        : _vm._e(),
                      row.renewal_cycle
                        ? _c(
                            "div",
                            { staticClass: "renewal-cycle" },
                            [
                              _c(
                                "el-tag",
                                {
                                  attrs: {
                                    type: "info",
                                    size: "mini",
                                    effect: "plain",
                                  },
                                },
                                [
                                  _vm._v(
                                    " #" +
                                      _vm._s(row.renewal_cycle) +
                                      " " +
                                      _vm._s(
                                        _vm.getSubscriptionPeriodLabel(
                                          row.subscription_period
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      row.notes
                        ? _c(
                            "div",
                            { staticClass: "event-notes" },
                            [
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content: row.notes,
                                    placement: "top",
                                    "open-delay": 300,
                                  },
                                },
                                [
                                  _c("span", { staticClass: "notes-text" }, [
                                    _vm._v(
                                      _vm._s(_vm.truncateNotes(row.notes))
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.isSandboxEvent(row)
                        ? _c(
                            "div",
                            { staticClass: "sandbox-indicator" },
                            [
                              _c(
                                "el-tag",
                                {
                                  attrs: {
                                    type: "warning",
                                    size: "mini",
                                    effect: "plain",
                                  },
                                },
                                [
                                  _c("i", { staticClass: "el-icon-cpu" }),
                                  _vm._v(" Sandbox "),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Platform", align: "center", width: "110" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "div",
                      { staticClass: "platform-cell" },
                      [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type:
                                row.platform === "ios" ? "primary" : "success",
                              size: "small",
                              effect: "dark",
                            },
                          },
                          [
                            _c("i", {
                              class:
                                row.platform === "ios"
                                  ? "el-icon-mobile-phone"
                                  : "el-icon-mobile",
                            }),
                            _vm._v(
                              " " +
                                _vm._s(
                                  row.platform === "ios" ? "iOS" : "Android"
                                ) +
                                " "
                            ),
                          ]
                        ),
                        row.is_test || row.isTest
                          ? _c(
                              "el-tag",
                              {
                                staticStyle: { "margin-top": "2px" },
                                attrs: { type: "warning", size: "mini" },
                              },
                              [_vm._v("TEST")]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "User", align: "left", width: "240" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "div",
                      { staticClass: "user-cell" },
                      [
                        row.user_id && row.user_email
                          ? [
                              row.user_name
                                ? _c("div", { staticClass: "user-name" }, [
                                    _c("i", { staticClass: "el-icon-user" }),
                                    _vm._v(" " + _vm._s(row.user_name) + " "),
                                  ])
                                : _vm._e(),
                              _c("div", { staticClass: "user-email" }, [
                                _vm._v(_vm._s(row.user_email)),
                              ]),
                              _c(
                                "div",
                                {
                                  staticClass: "user-id clickable",
                                  on: {
                                    click: function ($event) {
                                      return _vm.openUserDetail(row.user_id)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "ID: " +
                                      _vm._s(_vm.truncateUserId(row.user_id))
                                  ),
                                ]
                              ),
                            ]
                          : row.user_id && !row.user_email
                          ? [
                              _c("div", { staticClass: "user-partial" }, [
                                _c("i", {
                                  staticClass: "el-icon-warning-outline",
                                  staticStyle: { color: "#e6a23c" },
                                }),
                                _c("span", [_vm._v("User Found")]),
                              ]),
                              _c(
                                "div",
                                {
                                  staticClass: "user-id clickable",
                                  on: {
                                    click: function ($event) {
                                      return _vm.openUserDetail(row.user_id)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "ID: " +
                                      _vm._s(_vm.truncateUserId(row.user_id))
                                  ),
                                ]
                              ),
                              _c("div", { staticClass: "user-hint" }, [
                                _vm._v("Email not available"),
                              ]),
                            ]
                          : row.user_email && !row.user_id
                          ? [
                              _c("div", { staticClass: "user-email" }, [
                                _vm._v(_vm._s(row.user_email)),
                              ]),
                              _c("div", { staticClass: "user-pending" }, [
                                _c("i", {
                                  staticClass: "el-icon-link",
                                  staticStyle: { color: "#909399" },
                                }),
                                _c("span", [_vm._v("User ID not linked")]),
                              ]),
                            ]
                          : [
                              _c("div", { staticClass: "user-unknown" }, [
                                _c("i", {
                                  staticClass: "el-icon-question",
                                  staticStyle: { color: "#909399" },
                                }),
                                _c("span", [_vm._v("Pending User Link")]),
                              ]),
                              _c("div", { staticClass: "user-hint" }, [
                                _vm._v(
                                  " Webhook received before user verification "
                                ),
                              ]),
                            ],
                      ],
                      2
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Product", align: "left", width: "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("div", { staticClass: "product-cell" }, [
                      _c("div", { staticClass: "product-name" }, [
                        _vm._v(
                          " " + _vm._s(_vm.getProductDisplayName(row)) + " "
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "product-details" },
                        [
                          row.subscription_period
                            ? _c(
                                "el-tag",
                                {
                                  attrs: {
                                    type: _vm.getSubscriptionPeriodTag(
                                      row.subscription_period
                                    ),
                                    size: "mini",
                                    effect: "plain",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.getSubscriptionPeriodLabel(
                                          row.subscription_period
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          row.price_amount
                            ? _c("span", { staticClass: "product-price" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.formatPrice(
                                        row.price_amount,
                                        row.price_currency
                                      )
                                    ) +
                                    " "
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "product-id" }, [
                        _vm._v(_vm._s(row.product_id)),
                      ]),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Status", align: "center", width: "130" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "div",
                      { staticClass: "status-cell" },
                      [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.getStatusTag(row.status),
                              size: "small",
                              effect: "dark",
                            },
                          },
                          [
                            _c("i", {
                              class: _vm.getStatusIcon(row.status),
                              staticStyle: { "margin-right": "4px" },
                            }),
                            _vm._v(
                              " " + _vm._s(_vm.getStatusLabel(row.status)) + " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Event Date", align: "center", width: "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("div", { staticClass: "date-cell" }, [
                      _c("div", { staticClass: "date-main" }, [
                        _vm._v(_vm._s(_vm.formatDateShort(row.event_date))),
                      ]),
                      _c("div", { staticClass: "date-time" }, [
                        _vm._v(_vm._s(_vm.formatTime(row.event_date))),
                      ]),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Expires", align: "center", width: "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    row.expires_date
                      ? _c("div", { staticClass: "date-cell" }, [
                          _c("div", { staticClass: "date-main" }, [
                            _vm._v(
                              _vm._s(_vm.formatDateShort(row.expires_date))
                            ),
                          ]),
                          _c("div", { staticClass: "date-time" }, [
                            _vm._v(_vm._s(_vm.formatTime(row.expires_date))),
                          ]),
                          _vm.isExpiringSoon(row.expires_date)
                            ? _c(
                                "div",
                                { staticClass: "expiry-warning" },
                                [
                                  _c(
                                    "el-tag",
                                    {
                                      attrs: { type: "warning", size: "mini" },
                                    },
                                    [_vm._v("Expiring soon")]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ])
                      : _c("span", { staticClass: "no-data" }, [_vm._v("-")]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Actions", align: "center", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("el-button", {
                      attrs: {
                        type: "primary",
                        size: "mini",
                        icon: "el-icon-view",
                        circle: "",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.showDetails(row)
                        },
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("el-pagination", {
        staticStyle: { "margin-top": "20px", "text-align": "right" },
        attrs: {
          "current-page": _vm.listQuery.page,
          "page-sizes": [20, 50, 100],
          "page-size": _vm.listQuery.limit,
          total: _vm.total,
          layout: "total, sizes, prev, pager, next, jumper",
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
        },
      }),
      _c(
        "el-dialog",
        {
          staticClass: "details-dialog",
          attrs: {
            title: _vm.getDialogTitle(_vm.selectedEvent),
            visible: _vm.detailsDialogVisible,
            width: "700px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.detailsDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-descriptions",
            { attrs: { column: 2, border: "", size: "small" } },
            [
              _c("el-descriptions-item", { attrs: { label: "Event ID" } }, [
                _c("span", { staticClass: "mono" }, [
                  _vm._v(_vm._s(_vm.selectedEvent.id)),
                ]),
              ]),
              _c(
                "el-descriptions-item",
                { attrs: { label: "Event Type" } },
                [
                  _c(
                    "el-tag",
                    {
                      attrs: {
                        type: _vm.getEventTypeTag(_vm.selectedEvent.event_type),
                        size: "small",
                      },
                    },
                    [
                      _c("i", {
                        class: _vm.getEventTypeIcon(
                          _vm.selectedEvent.event_type
                        ),
                        staticStyle: { "margin-right": "4px" },
                      }),
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.getEventTypeLabel(_vm.selectedEvent.event_type)
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _vm.selectedEvent.event_subtype
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            "margin-top": "4px",
                            "font-size": "12px",
                            color: "#909399",
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.getEventSubtypeLabel(
                                  _vm.selectedEvent.event_subtype
                                )
                              ) +
                              " "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: "Platform" } },
                [
                  _c(
                    "el-tag",
                    {
                      attrs: {
                        type:
                          _vm.selectedEvent.platform === "ios"
                            ? "primary"
                            : "success",
                        size: "small",
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.selectedEvent.platform === "ios"
                              ? "iOS"
                              : "Android"
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _vm.isSandboxEvent(_vm.selectedEvent)
                    ? _c(
                        "el-tag",
                        {
                          staticStyle: { "margin-left": "8px" },
                          attrs: { type: "warning", size: "mini" },
                        },
                        [_vm._v(" Sandbox ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: "Status" } },
                [
                  _c(
                    "el-tag",
                    {
                      attrs: {
                        type: _vm.getStatusTag(_vm.selectedEvent.status),
                        size: "small",
                        effect: "dark",
                      },
                    },
                    [
                      _c("i", {
                        class: _vm.getStatusIcon(_vm.selectedEvent.status),
                        staticStyle: { "margin-right": "4px" },
                      }),
                      _vm._v(
                        " " +
                          _vm._s(_vm.getStatusLabel(_vm.selectedEvent.status)) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: "User ID" } },
                [
                  _vm.selectedEvent.user_id
                    ? _c("span", { staticClass: "mono" }, [
                        _vm._v(_vm._s(_vm.selectedEvent.user_id)),
                      ])
                    : _c("el-tag", { attrs: { type: "info", size: "mini" } }, [
                        _vm._v("Pending Link"),
                      ]),
                ],
                1
              ),
              _c("el-descriptions-item", { attrs: { label: "User" } }, [
                _vm.selectedEvent.user_name
                  ? _c("div", [_vm._v(_vm._s(_vm.selectedEvent.user_name))])
                  : _vm._e(),
                _c("div", [
                  _vm._v(
                    _vm._s(_vm.selectedEvent.user_email || "Not available")
                  ),
                ]),
              ]),
              _c("el-descriptions-item", { attrs: { label: "Product" } }, [
                _c("div", { staticStyle: { "font-weight": "500" } }, [
                  _vm._v(_vm._s(_vm.getProductDisplayName(_vm.selectedEvent))),
                ]),
                _c(
                  "div",
                  { staticStyle: { "font-size": "11px", color: "#909399" } },
                  [_vm._v(_vm._s(_vm.selectedEvent.product_id))]
                ),
              ]),
              _c(
                "el-descriptions-item",
                { attrs: { label: "Subscription" } },
                [
                  _vm.selectedEvent.subscription_period
                    ? _c(
                        "el-tag",
                        {
                          attrs: {
                            type: _vm.getSubscriptionPeriodTag(
                              _vm.selectedEvent.subscription_period
                            ),
                            size: "small",
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.getSubscriptionPeriodLabel(
                                  _vm.selectedEvent.subscription_period
                                )
                              ) +
                              " "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm.selectedEvent.renewal_cycle
                    ? _c("span", { staticStyle: { "margin-left": "8px" } }, [
                        _vm._v(
                          " Cycle #" +
                            _vm._s(_vm.selectedEvent.renewal_cycle) +
                            " "
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _c("el-descriptions-item", { attrs: { label: "Price" } }, [
                _vm.selectedEvent.price_amount
                  ? _c(
                      "span",
                      {
                        staticStyle: {
                          color: "#67c23a",
                          "font-weight": "600",
                          "font-size": "14px",
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.formatPrice(
                                _vm.selectedEvent.price_amount,
                                _vm.selectedEvent.price_currency
                              )
                            ) +
                            " "
                        ),
                      ]
                    )
                  : _c("span", { staticClass: "no-data" }, [
                      _vm._v("Not recorded"),
                    ]),
              ]),
              _c(
                "el-descriptions-item",
                { attrs: { label: "Auto Renew" } },
                [
                  _c(
                    "el-tag",
                    {
                      attrs: {
                        type: _vm.selectedEvent.auto_renew_status
                          ? "success"
                          : "info",
                        size: "mini",
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.selectedEvent.auto_renew_status
                              ? "Enabled"
                              : "Disabled"
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: "Transaction ID" } },
                [
                  _c(
                    "span",
                    {
                      staticClass: "mono",
                      staticStyle: { "font-size": "11px" },
                    },
                    [_vm._v(_vm._s(_vm.selectedEvent.transaction_id))]
                  ),
                ]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: "Original TX ID" } },
                [
                  _c(
                    "span",
                    {
                      staticClass: "mono",
                      staticStyle: { "font-size": "11px" },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.selectedEvent.original_transaction_id || "-")
                      ),
                    ]
                  ),
                ]
              ),
              _c("el-descriptions-item", { attrs: { label: "Event Date" } }, [
                _vm._v(_vm._s(_vm.formatDate(_vm.selectedEvent.event_date))),
              ]),
              _c(
                "el-descriptions-item",
                { attrs: { label: "Purchase Date" } },
                [
                  _vm._v(
                    _vm._s(_vm.formatDate(_vm.selectedEvent.purchase_date))
                  ),
                ]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: "Expires Date" } },
                [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.formatDate(_vm.selectedEvent.expires_date))
                    ),
                  ]),
                  _vm.isExpiringSoon(_vm.selectedEvent.expires_date)
                    ? _c(
                        "el-tag",
                        {
                          staticStyle: { "margin-left": "8px" },
                          attrs: { type: "warning", size: "mini" },
                        },
                        [_vm._v(" Soon ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c("el-descriptions-item", { attrs: { label: "Cancellation" } }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.getCancellationReasonLabel(
                        _vm.selectedEvent.cancellation_reason
                      )
                    ) +
                    " "
                ),
              ]),
              _c(
                "el-descriptions-item",
                { attrs: { label: "Notification Type", span: 2 } },
                [
                  _c("span", { staticClass: "mono" }, [
                    _vm._v(_vm._s(_vm.selectedEvent.notification_type || "-")),
                  ]),
                ]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: "Notes", span: 2 } },
                [
                  _vm._v(
                    " " + _vm._s(_vm.selectedEvent.notes || "No notes") + " "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "user-detail-dialog",
          attrs: {
            title: "User Detail",
            visible: _vm.userDetailVisible,
            width: "800px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.userDetailVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.userDetailLoading,
                  expression: "userDetailLoading",
                },
              ],
            },
            [
              _c(
                "el-tabs",
                {
                  model: {
                    value: _vm.userDetailTab,
                    callback: function ($$v) {
                      _vm.userDetailTab = $$v
                    },
                    expression: "userDetailTab",
                  },
                },
                [
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "Basic Information", name: "basic" } },
                    [
                      _c(
                        "el-form",
                        {
                          attrs: {
                            "label-position": "left",
                            "label-width": "150px",
                          },
                        },
                        [
                          _c(
                            "el-row",
                            { attrs: { gutter: 20 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "First Name" } },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          value: _vm.userDetailData.firstName,
                                          disabled: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "Last Name" } },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          value: _vm.userDetailData.lastName,
                                          disabled: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            { attrs: { gutter: 20 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "Email" } },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          value: _vm.userDetailData.email,
                                          disabled: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            { attrs: { gutter: 20 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 8 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "Country Code" } },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          value: _vm.userDetailData.countryCode,
                                          disabled: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 16 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "Phone Number" } },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          value: _vm.userDetailData.phoneNumber,
                                          disabled: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            { attrs: { gutter: 20 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "Country" } },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          value: _vm.userDetailData.country,
                                          disabled: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "City" } },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          value: _vm.userDetailData.city,
                                          disabled: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "Account Settings", name: "settings" } },
                    [
                      _c(
                        "el-form",
                        {
                          attrs: {
                            "label-position": "left",
                            "label-width": "150px",
                          },
                        },
                        [
                          _c(
                            "el-row",
                            { attrs: { gutter: 20 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "User Type" } },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          value: _vm.userDetailData.userType,
                                          disabled: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "Cane ID" } },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          value: _vm.userDetailData.caneId,
                                          disabled: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            { attrs: { gutter: 20 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "Is Assistant" } },
                                    [
                                      _c("el-switch", {
                                        attrs: {
                                          value: _vm.userDetailData.isAssistant,
                                          disabled: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "Is Premium" } },
                                    [
                                      _c("el-switch", {
                                        attrs: {
                                          value: _vm.userDetailData.isPremium,
                                          disabled: "",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "WeAssist", name: "consult" } },
                    [
                      _c(
                        "el-form",
                        {
                          attrs: {
                            "label-position": "left",
                            "label-width": "180px",
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "Current Consult Time" } },
                            [
                              _c("el-input", {
                                staticStyle: { width: "120px" },
                                attrs: {
                                  value: _vm.userDetailData.consultSeconds
                                    ? Math.round(
                                        _vm.userDetailData.consultSeconds / 60
                                      )
                                    : 0,
                                  disabled: "",
                                },
                              }),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "margin-left": "10px",
                                    color: "#909399",
                                  },
                                },
                                [_vm._v("minutes")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: "Features & Entitlements",
                        name: "entitlements",
                      },
                    },
                    [
                      _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.entitlementsLoading,
                              expression: "entitlementsLoading",
                            },
                          ],
                          staticStyle: { width: "100%" },
                          attrs: {
                            data: _vm.userEntitlements,
                            border: "",
                            size: "small",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: { label: "Feature", width: "150" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ row }) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          row.feature?.name ||
                                            row.feature?.featureKey ||
                                            "N/A"
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "sourceType",
                              label: "Source",
                              width: "120",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: { label: "Start Date", width: "130" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ row }) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.formatDetailDate(row.startDate)
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: { label: "End Date", width: "130" },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ row }) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.formatDetailDate(row.endDate)
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "Status",
                              width: "100",
                              align: "center",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ row }) {
                                  return [
                                    _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          type: row.isActive
                                            ? "success"
                                            : "danger",
                                          size: "small",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              row.isActive
                                                ? "Active"
                                                : "Inactive"
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.userDetailVisible = false
                    },
                  },
                },
                [_vm._v("Close")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }